import { useState, useCallback, useRef } from 'react';

function useEventTarget(params) {
  var _ref = params || {},
      initialValue = _ref.initialValue,
      transformer = _ref.transformer;

  var _useState = useState(initialValue),
      value = _useState[0],
      setValue = _useState[1];

  var reset = useCallback(function () {
    return setValue(initialValue);
  }, [setValue]);
  var transformerRef = useRef(transformer);
  transformerRef.current = transformer;
  var onChange = useCallback(function (e) {
    var _value = e.target.value;

    if (typeof transformerRef.current === 'function') {
      return setValue(transformerRef.current(_value));
    } // no transformer => U and T should be the same


    return setValue(_value);
  }, [setValue]);
  return [value, {
    onChange: onChange,
    reset: reset
  }];
}

export default useEventTarget;